export default "__VITE_ASSET__0ab64315__"